import { useEffect, useState } from "react";
import { MessageCircle } from "lucide-react";
import api from "../lib/api";
import { trackEvent } from "../lib/analytics";

export default function WhatsAppFloat() {
  const [wa, setWa] = useState(null);
  useEffect(() => { api.get("/settings/public").then(({ data }) => setWa(data.whatsapp)).catch(() => {}); }, []);
  if (!wa) return null;
  const href = `https://wa.me/${wa}?text=${encodeURIComponent("Merhaba, Ata Angora ürünleri hakkında bilgi almak istiyorum.")}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-float-button"
      onClick={() => trackEvent("whatsapp_click", { location: "yuzan_buton" })}
      aria-label="WhatsApp iletişim"
      className="fixed bottom-20 md:bottom-6 right-4 z-40 w-14 h-14 rounded-full bg-[#25D366] hover:bg-[#20ba5a] shadow-lg shadow-green-900/30 flex items-center justify-center hover:scale-110 transition-transform"
    >
      <MessageCircle className="w-7 h-7 text-white" />
    </a>
  );
}
